var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 20q-.825 0-1.413-.588A1.92 1.92 0 0 1 2 18V6q0-.825.588-1.413A1.92 1.92 0 0 1 4 4h16q.825 0 1.413.588T22 6v12q0 .825-.588 1.413A1.92 1.92 0 0 1 20 20zm8-7L4 8v10h16V8zm0-2 8-5H4zM4 8V6v12z"
  })));
};
export default SvgMail;